/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Observable, of } from 'rxjs'
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators'

export function autocomplete<T, R>(dataCb: (query: T) => Observable<R>, delay = 400) {
  return (source$: Observable<T>) =>
    source$.pipe(
      debounceTime(delay),
      distinctUntilChanged(),
      switchMap((searchTerm) => (searchTerm ? dataCb(searchTerm) : of([]))),
    )
}
